<template>
  <div id="app">
    <t-layout :isMobile="isMobile">
      <keep-alive>
        <router-view v-if="isRouterAlive" />
      </keep-alive>
    </t-layout>
  </div>
</template>


<script>
import TLayout from './components/tLayout/index.vue'
export default {
  components: { TLayout },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    const ua = window.navigator.userAgent;
    // 利用设备标识进行pc端、移动端适配
    let isMobile = false;
    if (ua.indexOf('iPhone') >= 0) isMobile = true;
    if (ua.indexOf('Android') >= 0) isMobile = true;

    return {
      isRouterAlive: true,
      isMobile
    }
  },
  mounted () {

  },

  created () {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* -moz-user-select:none;
  -webkit-user-select:none;
  user-select:none; */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue